import React, {useState} from "react";
import {Page} from "../../components/page/page";
import {ChooseList} from "../../components/choose-list/choose-list";
import {useDispatch} from "react-redux";
import {setTraits} from "../../store/stateSlice";

const options = [
  {
    title: "emotional",
    icon: "🎯",
  },
  {
    title: "intelligent",
    icon: "🤝",
  },
  {
    title: "introverted",
    icon: "🎨",
  },
  {
    title: "logical",
    icon: "✨",
  },
  {
    title: "sincere",
    icon: "😇",
  },
];

const TraitsPage = () => {
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  return (
    <Page
      title="Which of the following traits reflect your personality?"
      currentStep={9}
      nextPageLink="../horoscope-preparing"
      canGoToNextPage={selectedOptions.length === 3}
      onContinue={() => {
        dispatch(setTraits(selectedOptions));
      }}
    >
      <ChooseList options={options} maxSelected={3} onChange={handleChange} />
    </Page>
  );
};

export { TraitsPage };
